import { generateState } from '../builder'

export default {
  user: null,
  ...generateState('login'),
  ...generateState('logout'),
  ...generateState('me'),
}
